// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-664da674]{fill:var(--v-primary-base);stroke:var(--v-primary-base)}.cls-2[data-v-664da674]{fill:#fff}", ""]);
// Exports
module.exports = exports;
